import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import TopBar from "../../components/shared/TopBar";
import { useStatus } from "../../hooks/useStatus";
import { makeStyles } from "@mui/styles";
import { forgotPassword } from "../../redux/actions/userActions";
import {
  PENDING,
  FULFILLED,
} from "../../redux/constants/actionStatusConstants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const useStyles = makeStyles((theme) => ({
  forgotPasswordBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "5rem",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      marginTop: "3rem",
    },
  },
  forgotPasswordForm: {
    display: "flex",
    flexDirection: "column",
    marginTop: "2rem",
    width: "25rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const ForgotPassword = () => {
  const { status } = useStatus(forgotPassword);
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const response = await dispatch(forgotPassword(data));
    if (response?.meta?.requestStatus === FULFILLED) {
      toast.success(
        <Typography color="success">
          If the email matches an existing user we will send a code to your
          mobile phone number :)
        </Typography>,
        {
          position: "top-center",
        }
      );
      navigate(`/insert-code/${data.email}`);
    }
  };
  return (
    <div className={classes.signUp}>
      <TopBar />
      <div className={classes.forgotPasswordBody}>
        <Typography variant="h3">Trouble with your password?</Typography>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.forgotPasswordForm}
        >
          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...register("email", {
                  required: true,
                  pattern:
                    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
                })}
                {...field}
                variant="outlined"
                placeholder="Email Address*"
                sx={{ width: "100%" }}
                error={errors.email}
                helperText={
                  (errors.email?.type === "required" && "Email is required.") ||
                  (errors.email?.type === "pattern" &&
                    "Email must be a valid email address.")
                }
              />
            )}
          />
          <Button
            type="submit"
            disabled={status === PENDING}
            sx={{ color: "white", mt: "2rem" }}
            variant="contained"
            color="navy"
          >
            {(status === PENDING && (
              <CircularProgress
                sx={{
                  color: "#022752",
                  width: "1.5rem !important",
                  height: "1.5rem !important",
                }}
              />
            )) ||
              "Reset Password"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
